export const COMMENT_OPTIONS = [
    { value: "shop_closed", label: "Торгова точка зачинена" },
    { value: "not_in_stock", label: "Немає в наявності" },
    { value: "not_available_am", label: "Немає в АМ" },
    { value: "moved", label: "Пересорт" },
    { value: "less_3bottles", label: "ТЗ менше 3 пл." },
    { value: "not_found", label: "Не зміг знайти" },
    { value: "not_accepted", label: "Товар не прийнято" },
    { value: "not_started", label: "Акція не стартувала" },
    { value: "no_light", label: "Немає світла" },
    { value: "air_alarm", label: "Повітряна тривога" },
];
